<template>
  <div>
    <CRow>
      <CCol
        md="12"
        lg="12"
        xl="12"
        xxl="12"
        xs="12"
        sm="12"
      >
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Kits"
          icon="fas fa-box"
          btn_name="Kit"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
          :buttonBack="true"
          :myButtons = "myButtons"
          @mtd_table_product = "mtd_table_product"
        />
      </CCol>
    </CRow>

    <!-- modal de formulario -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'lg'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
       
        <CCol sm="6">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="kit.name"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="Precio Venta"
            placeholder="Digite precio"
            v-model="kit.price"
          />
        </CCol>
        <CCol v-if="modal.action == 'store'" xs="12" sm="12" md="12" lg="12" xl="12" class="mb-2">
          <label class="mb-2">Sedes donde registrar el Kit:</label>
          <div class="campus-table-container border p-3 rounded">
            <div v-if="data_campus.length === 0" class="text-muted">
              No hay sedes disponibles
            </div>
            <table v-else class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>Sede</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="campus in data_campus" :key="campus.id">
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" :id="'campus-' + campus.id" :value="campus.id"
                        v-model="selectedCampuses" />
                      <label class="custom-control-label" :for="'campus-' + campus.id">
                        {{ campus.name }}
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-2">
              <a href="#" @click.prevent="selectAllCampuses" class="mr-3">Seleccionar todas</a>
              <a href="#" @click.prevent="deselectAllCampuses">Quitar todas</a>
            </div>
          </div>
        </CCol>
        <CCol
          v-if="modal.action == 'store'"
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="mb-2"
        >
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="kit.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>
     <!-- modal de Eliminar -->
    <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar Kit'"
    :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
    <cModalKitProduct
     @mtdaddservicios="mtdaddservicios"
     :provider_id="provider_id" 
     :title="modalService.title" 
     :boo_modal="modalService.modal_form" 
     @closeModalService="closeModalService" 
     :id_campu ="id_campu"
     />
  </div>
</template>
  
  <script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "campu_name", label: "Sede", _style: "width:20%;" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "price", label: "Precio Venta", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../shared/datatable/Table.vue";
import CModalForm from "../../shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import cSelectForm from "../../../components/shared/inputs/cSelect.vue";
import CSwitchVue from "../../shared/switch/CSwitch.vue";
import cModalKitProduct from "../../shared/modals/cModalKitProduct.vue";
export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    cSelectForm,
    cModalKitProduct
  },
  data() {
    return {
      prefix: "kits",
      fields,
      id_campu:null,
      data: [],
      dataProduct:[],
      selectedCampuses: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
        modal_form_barcode: false,
        modal_form_price: false,
        modal_form_productUnit: false,
      },
      modalService: {
        title: "",
        modal_form: false,
      },
      kit: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        name: "",
        price: 0,
        state: 0,
        prds:[]
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      barcodeTables: [],
      priceTables: [],
      productUnitTables: [],
      nextBarcodeTableId: 1, // Counter for unique table ID
      nextPriceTableId: 1, // Counter for unique table ID
      nextProductUnitTableId: 1, // Counter for unique table ID
      myButtons: [
        {
          class: "btn-sm",
          color: "warning",
          tooltip: "Agregar Productos",
          action: "mtd_table_product",
          icon: "fas fa-box",
        },
        
      ],
      provider_id:null
    };
  },
  computed: {
    cpStatus: function () {
      return this.kit.state === 1;
    },
    cp_button: function () {
        return (this.kit.name.trim() === "" || this.selectedCampuses.length ==0 ) && this.modal.action == "store";
      }
  },
  watch: {
    selectedCampuses: {
      handler(value) {
        this.product.campus_ids = [...value];
      },
      deep: true,
    },
  },
  created() {
    this.getCampus();
    this.mtd_getdata();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data;
          this.data.forEach((item) => {
            switch (item.state) {
              case "Activo":
                item.status = "Activo";
                break;
              case "Inactivo":
                item.status = "Inactivo";
                break;
              default:
                item.status = "Desconocido";
            }
          });
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
          this.dataProduct= response.data.prd;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    changeSwitch: function (payload) {
      this.kit.state = payload == true ? 1 : 0;
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Kit")
        : (this.modal.title = "Editar Kit");
      action == "store"
        ? (this.product = {
            id: "",
            company_id: this.$store.getters.get_company.id,
            name: "",
            state: "",
            campus_ids: [],
          })
        : (this.product = { ...this.product });
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },

    /** --- */
    isCampusSelected(campusId) {
      return this.selectedCampuses.includes(campusId);
    },
    // Método para activar/desactivar inputs al seleccionar/deseleccionar campus
    // toggleCampusInputs(campusId) {
    //   if (!this.isCampusSelected(campusId)) {
    //     // Si se deselecciona, limpiar los valores
    //     this.campusPrices[campusId] = "";
    //     this.campusStockMin[campusId] = "";
    //   } else {
    //     // Si se selecciona, inicializar con valores por defecto
    //     this.campusPrices[campusId] = this.campusPrices[campusId] || 0;
    //     this.campusStockMin[campusId] = this.campusStockMin[campusId] || 0;
    //   }
    // },
    // Validación para asegurar números positivos en los inputs
    validatePositiveInput(obj, key) {
      const value = parseInt(obj[key], 10);
      if (isNaN(value) || value < 0) {
        obj[key] = 0;
      }
    },
    selectAllCampuses() {
      // Verificar si todas las sedes ya están seleccionadas
      const allSelected =
        this.data_campus.length === this.selectedCampuses.length;

      if (allSelected) {
        return; // Ya están todas seleccionadas
      }

      // Seleccionar todas las sedes e inicializar sus valores
      this.selectedCampuses = this.data_campus.map((campus) => {
        return campus.id;
      });
    },

    deselectAllCampuses() {
      // Limpiar todas las selecciones y valores
      this.selectedCampuses = [];
    },

    // selectAllCampuses() {
    //   this.selectedCampuses = this.data_campus.map(campus => campus.id);
    // },
    // deselectAllCampuses() {
    //   this.selectedCampuses = [];
    // },
    validationNumber() {
      const quantity = parseInt(event.target.value, 10);
      if (quantity < 1) {
        this.product.stock_min = 1;
      }
    },
    preventDecimal(event) {
      // Prevenir que se ingresen puntos decimales o comas
      if (event.key === "." || event.key === ",") {
        event.preventDefault();
      }
    },
    
    
    mtd_action: function () {
      this.kit.campus =this.selectedCampuses
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.kit
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({
              title: "Producto ya resgistrado",
              icon: "warning",
            });
          } else {
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              // let updatedProduct = response.data.data;
              // let index = this.data.findIndex(
              //   (product) => product.id === updatedProduct.id
              // );
              // if (index !== -1) {
              //   this.$set(this.data, index, updatedProduct);
              // }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            // this.selectedCampuses = [];
            // this.campusPrices = {};
            // this.campusStockMin = {};
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.kit = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      }).then((response) => {
        this.mtd_getdata();
        this.modal_delete = {
          boo: false,
          item: [],
        };

        Swal.fire({
          title: "ELIMINADO CORRECTAMENTE",
          icon: "success",
        });
      });
    },
    
    mtd_table_barcode: function (id) {
      if (this.priceTables.length != 0) {
        this.removePriceTable(this.priceTables[0].id);
      }
      if (this.productUnitTables.length != 0) {
        this.removeProductUnitTable(this.productUnitTables[0].id);
      }
      if (this.barcodeTables.length == 1) {
        this.removeBarcodeTable(this.barcodeTables[0].id);
      }
      // this.tableColSize = 7;
      this.barcode.product_id = id.Id;
      this.barcode.name = "";

      // Ocultar la tabla principal
      this.showMainTable = false;

      // Add a new barcode table
      if (this.nextBarcodeTableId == 1) {
        const newBarcodeTable = {
          id: this.nextBarcodeTableId,
          data: [], // You can fill this with actual barcode data as needed
          fields: [
            { key: "index", label: "Id", _style: "width:1%" },
            { key: "name", label: "Nombre", _style: "width:20%;" },
          ],
          name_product: id.name,
        };
        this.barcodeTables.push(newBarcodeTable);
        this.mtd_getdata_barcode(newBarcodeTable.id, id.Id);
        this.nextBarcodeTableId += 1;
      }
    },
    removeBarcodeTable(tableId) {
      this.nextBarcodeTableId = 1;
      this.barcodeTables = this.barcodeTables.filter(
        (table) => table.id !== tableId
      );

      // Si no quedan más tablas de códigos de barras, restablece el tamaño de la columna principal
      if (this.barcodeTables.length === 0) {
        // this.tableColSize = 12;
        this.showMainTable = true;
      }
    },
    mtd_barcode: function () {
      // this.tableColSize = 7;
      this.modal.modal_form_barcode = true;
      this.modal.title = "Agregar Codigo de Barras";
      this.barcode.name = "";
    },

    mtd_action_barcode: function () {
      let color = "success";
      let message = "";
      this.post({
        url: this.$store.getters.get__url + "/barcodes/store",
        token: this.$store.getters.get__token,
        params: this.barcode,
      })
        .then((response) => {
          message = "REGISTRADO CORRECTAMENTE";
          this.mtd_getdata_barcode(
            this.barcodeTables[0].id,
            this.barcode.product_id
          );
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            modal_form_barcode: false,
            modal_form_price: false,
            modal_form_productUnit: false,
          };
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_getdata_barcode: function (tableId, productId) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byBarcode/" +
          this.$store.getters.get_company.id +
          "/" +
          productId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // this.data = response.data.data;
          const tableIndex = this.barcodeTables.findIndex(
            (table) => table.id === tableId
          );
          if (tableIndex !== -1) {
            this.$set(
              this.barcodeTables[tableIndex],
              "data",
              response.data.data
            );
            // Agregar un índice a cada elemento en la data
            let index = 1;
            this.barcodeTables[tableIndex].data.forEach((item) => {
              item.index = index;
              index++;
            });
          }
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtd_delete_barcode(item) {
      // Muestra una confirmación antes de eliminar
      Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminarlo",
      }).then((result) => {
        if (result.isConfirmed) {
          this.post({
            url: this.$store.getters.get__url + "/barcodes/destroy",
            token: this.$store.getters.get__token,
            params: {
              id: item.id,
            },
          })
            .then((response) => {
              if (response.data) {
                // Eliminar el barcode de la tabla localmente
                const tableIndex = this.barcodeTables.findIndex(
                  (table) => table.id == this.nextBarcodeTableId - 1
                ); // Asume que solo tienes un barcodeTable activo

                if (tableIndex !== -1) {
                  const barcodeIndex = this.barcodeTables[
                    tableIndex
                  ].data.findIndex((barcode) => barcode.id === item.id);
                  if (barcodeIndex !== -1) {
                    this.barcodeTables[tableIndex].data.splice(barcodeIndex, 1);
                  }
                }
                // this.barcodeTables[tableIndex].data = [];
                // this.mtd_getdata_barcode(this.barcodeTables[0].id, this.barcode.product_id);
                Swal.fire(
                  "¡Eliminado!",
                  "El código de barras ha sido eliminado.",
                  "success"
                );
              }
            })
            .catch((error) => {
              Swal.fire(
                "Error",
                "Ocurrió un error al eliminar el código de barras.",
                "error"
              );
            });
        }
      });
    },
    mtd_table_price: function (id) {
      if (this.barcodeTables.length != 0) {
        this.removeBarcodeTable(this.barcodeTables[0].id);
      }
      if (this.productUnitTables.length != 0) {
        this.removeProductUnitTable(this.productUnitTables[0].id);
      }
      if (this.priceTables.length == 1) {
        this.removePriceTable(this.priceTables[0].id);
      }

      // this.tableColSize = 7;
      this.price.product_id = id.Id;
      this.price.purchase_price = 0;
      this.price.sale_price = 0;

      // Ocultar la tabla principal
      this.showMainTable = false;

      // Add a new barcode table
      if (this.nextPriceTableId == 1) {
        const newPriceTable = {
          id: this.nextPriceTableId,
          data: [], // You can fill this with actual barcode data as needed
          fields: [
            { key: "index", label: "Id", _style: "width:1%" },
            {
              key: "sale_price",
              label: "Precio de venta",
              _style: "width:20%;",
            },
            {
              key: "purchase_price",
              label: "Precio de compra",
              _style: "width:20%;",
            },
            { key: "state", label: "Estado", _style: "width:5%;" },
          ],
          name_product: id.name,
        };
        this.priceTables.push(newPriceTable);
        this.mtd_getdata_price(newPriceTable.id, id.Id);
        this.nextPriceTableId += 1;
      }
    },
    removePriceTable(tableId) {
      this.nextPriceTableId = 1;
      this.priceTables = this.priceTables.filter(
        (table) => table.id !== tableId
      );

      // Si no quedan más tablas de códigos de barras, restablece el tamaño de la columna principal
      if (this.priceTables.length === 0) {
        // this.tableColSize = 12;
        this.showMainTable = true;
      }
    },
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/stock_transfer/getCampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.data_campus = response.data;
      });
    },
    mtd_price: function (action) {
      // this.tableColSize = 7;
      this.modal.modal_form_price = true;
      if (action == "update") {
        this.modal.title = "Editar Precio";
        this.modal.action = action;
      } else {
        this.modal.title = "Agregar Precio";
        this.modal.action = "store";
        // this.price.product_id="";
        this.price.purchase_price = 0;
        this.price.sale_price = 0;
        this.price.state = 0;
      }
    },
    mtd_getdata_price: function (tableId, productId) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byPrice/" +
          this.$store.getters.get_company.id +
          "/" +
          productId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // this.data = response.data.data;
          const tableIndex = this.priceTables.findIndex(
            (table) => table.id === tableId
          );
          if (tableIndex !== -1) {
            this.$set(this.priceTables[tableIndex], "data", response.data.data);
            // Agregar un índice a cada elemento en la data
            let index = 1;
            this.priceTables[tableIndex].data.forEach((item) => {
              item.index = index;
              index++;
            });
          }
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtd_show_price: function (id) {
      this.get({
        url: this.$store.getters.get__url + "/prices/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.price = response;
          this.mtd_price("update");
          // this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_table_productUnit: function (id) {
      if (this.priceTables.length != 0) {
        this.removePriceTable(this.priceTables[0].id);
      }
      if (this.barcodeTables.length != 0) {
        this.removeBarcodeTable(this.barcodeTables[0].id);
      }
      if (this.productUnitTables.length == 1) {
        this.removeProductUnitTable(this.productUnitTables[0].id);
      }

      // this.tableColSize = 7;
      this.productUnit.product_id = id.Id;
      this.productUnit.unit_id = "";

      // Ocultar la tabla principal
      this.showMainTable = false;

      // Add a new barcode table
      if (this.nextProductUnitTableId == 1) {
        const newProductUnitTable = {
          id: this.nextProductUnitTableId,
          data: [],
          fields: [
            { key: "index", label: "Id", _style: "width:1%" },
            { key: "unit_name", label: "Unidad", _style: "width:20%;" },
            { key: "state", label: "Estado", _style: "width:5%;" },
          ],
          name_product: id.name,
        };
        this.productUnitTables.push(newProductUnitTable);
        this.mtd_getdata_productUnit(newProductUnitTable.id, id.Id);
        this.nextProductUnitTableId += 1;
      }
    },
    removeProductUnitTable(tableId) {
      this.nextProductUnitTableId = 1;
      this.productUnitTables = this.productUnitTables.filter(
        (table) => table.id !== tableId
      );

      // Si no quedan más tablas de códigos de barras, restablece el tamaño de la columna principal
      if (this.productUnitTables.length === 0) {
        // this.tableColSize = 12;
        this.showMainTable = true;
      }
    },
    mtd_productUnit: function (action) {
      // this.tableColSize = 7;
      this.modal.modal_form_productUnit = true;

      if (action == "update") {
        this.modal.title = "Editar Producto x Unidad";
        this.modal.action = action;
        this.productUnit.unit_id = this.productUnit.unit.id;
      } else {
        this.modal.title = "Agregar Producto x Unidad";
        this.modal.action = "store";
        this.productUnit.unit_id = "";
        this.productUnit.state = 0;
      }
    },
    mtd_action_productUnit: function () {
      let color = "success";
      let message = "";
      this.post({
        url:
          this.$store.getters.get__url + "/productsunits/" + this.modal.action,
        token: this.$store.getters.get__token,
        params: this.productUnit,
      })
        .then((response) => {
          if (this.modal.action == "store") {
            message = "REGISTRADO CORRECTAMENTE";
            this.mtd_getdata_productUnit(
              this.productUnitTables[0].id,
              this.productUnit.product_id
            );
          } else {
            let updateProductxUnit = response.data.data;
            let index = this.productUnitTables[0].data.findIndex(
              (productUnit) => productUnit.id === updateProductxUnit.id
            );
            if (index !== -1) {
              this.$set(
                this.productUnitTables[0].data,
                index,
                updateProductxUnit
              );
            }
            message = "EDITADO CORRECTAMENTE";
            this.mtd_getdata_productUnit(
              this.productUnitTables[0].id,
              this.productUnit.product_id
            );
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            modal_form_productUnit: false,
          };
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_action_price: function () {
      let color = "success";
      let message = "";
      this.post({
        url: this.$store.getters.get__url + "/prices/" + this.modal.action,
        token: this.$store.getters.get__token,
        params: this.price,
      })
        .then((response) => {
          if (this.modal.action == "store") {
            message = "REGISTRADO CORRECTAMENTE";
            this.mtd_getdata_price(
              this.priceTables[0].id,
              this.price.product_id
            );
          } else {
            let updatedPrice = response.data.data;
            let index = this.priceTables[0].data.findIndex(
              (price) => price.id === updatedPrice.id
            );
            if (index !== -1) {
              this.$set(this.priceTables[0].data, index, updatedPrice);
            }
            message = "EDITADO CORRECTAMENTE";
            this.mtd_getdata_price(
              this.priceTables[0].id,
              this.price.product_id
            );
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            modal_form_price: false,
          };
          this.price = {
            id: "",
            product_id: "",
            sale_price: 0,
            purchase_price: 0,
            state: 0,
          };
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_getdata_productUnit: function (tableId, productId) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byProductUnit/" +
          this.$store.getters.get_company.id +
          "/" +
          productId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          const tableIndex = this.productUnitTables.findIndex(
            (table) => table.id === tableId
          );
          if (tableIndex !== -1) {
            this.$set(
              this.productUnitTables[tableIndex],
              "data",
              response.data.data
            );
            let index = 1;
            this.productUnitTables[tableIndex].data.forEach((item) => {
              item.index = index;
              index++;
            });
          }
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtd_show_productUnit: function (id) {
      this.get({
        url: this.$store.getters.get__url + "/productsunits/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.productUnit = response;
          this.mtd_productUnit("update");
        })
        .catch((errors) => {});
    },
    show_Unit: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/productsunits/byUnit/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.data_units.push({
              label: element.name,
              value: element.id,
              quantity: element.quantity,
            });
          });
        })
        .catch((errors) => {});
    },
    validatePositive(field) {
      if (this.price[field] < 0) {
        this.price[field] = 0; // Permite 0 pero no valores negativos
      }
    },
    mtd_table_product :function( item){
      this.provider_id = item.Id
      this.id_campu = item.campu_id
      this.modalService = {
        title: "Lista de Productos del " + item.name,
        modal_form: true,
      } 
    },
    closeModalService :function(){
      this.modalService = {
        title: "",
        modal_form: false,
      } 
      this.provider_id = null
      this.id_campu =null
    },
    mtdaddservicios:function( services){
      this.post({
                    url: this.$store.getters.get__url + "/" + this.prefix + "/addproductokit ",
                    token: this.$store.getters.get__token,
                    params: services,
                })
                .then(response => {
                  Swal.fire({
                      title: 'REGISTRADO CORRECTAMENTE',
                      icon: 'success',
                    });
                    this.mtd_getdata();
                    this.closeModalService()

                })
                .catch(error => {
                    console.log(error);
                })
    },
    
  },
  destroyed() {
    // console.log(this.dataStore);
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>
  
  <style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>